'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');
var collapsible = require('../../components/collapsible.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  transition: all 2s linear;\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  padding: 0px 0px 8px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  cursor: pointer;\n  padding: 8px 0px;\n  position: relative;\n  margin: 0px;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgb(136, 136, 136);\n\n  &:before {\n    content: '", "';\n    position: absolute;\n    right: 0px;\n    top: 50%;\n    transform: translateY(-50%);\n    line-height: 1;\n    font-family: pyticon;\n    font-weight: 400;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  border-radius: 0px;\n  padding: 0px;\n  background-color: transparent;\n  border-bottom: 0;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  border: 0px;\n  border-radius: 0px;\n  box-shadow: none;\n  background-color: transparent;\n  border-bottom: 1px solid rgb(41, 41, 41);\n  margin-bottom: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Panel = styled__default['default'].div(_templateObject());
var Heading = styled__default['default'].div(_templateObject2());
var Title = styled__default['default'].span(_templateObject3(), function (props) {
  return props.open ? '\\ea11' : '\\e982';
});
var Body = styled__default['default'].div(_templateObject4());
var Outer = styled__default['default'](collapsible['default'])(_templateObject5(), function (props) {
  return props.show ? "  \n  max-height: 1000px;\n  transition: max-height 1s ease-in-out;\n  " : "\n  max-height: 0;\n  transition: max-height 0.5s cubic-bezier(0, 1, 0, 1);\n  ";
});

var CollapsibleWrapper = function CollapsibleWrapper(_ref) {
  var propOpen = _ref.open,
      trigger = _ref.trigger,
      handleTriggerClick = _ref.handleTriggerClick,
      children = _ref.children;

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  React.useEffect(function () {
    setOpen(propOpen);
  }, [propOpen]);
  return /*#__PURE__*/React__default['default'].createElement(Panel, null, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "Collapsible"
  }, /*#__PURE__*/React__default['default'].createElement(Heading, {
    onClick: function onClick() {
      // setOpen(!open)
      handleTriggerClick();
    }
  }, /*#__PURE__*/React__default['default'].createElement(Title, {
    open: open
  }, trigger)), /*#__PURE__*/React__default['default'].createElement(Outer, {
    show: open
  }, /*#__PURE__*/React__default['default'].createElement(Body, null, children))));
};

exports.default = CollapsibleWrapper;
